<template>
  <b-modal
    ref="modal"
    :title="$t('set-value')"
    :ok-title="$t('close')"
    ok-only
    @hide="close"
  >
    <setting-item :setting-var="settingVar" />
  </b-modal>
</template>

<script>
export default {
  name: 'setValueModal',
  props: {
    settingVar: {
      required: false,
    },
  },
  methods: {
    show() {
      this.$refs.modal.show();
    },
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped>

</style>
